export const VERSION = "v0.1.22";
export const EXT_TITLE = "Mass Mapper UI";